import {GET, POST} from "../util";

const inspectionUrl = "api/buyer-payments-receivables-inspection";

const url = {
    inspection: {
        accounts: `${inspectionUrl}/accounts`,
        list: `${inspectionUrl}/list/:accountId`,
        details: `${inspectionUrl}/details/:assignmentId`,
    }
};

const investorPaymentsReceivablesApi = {
    inspection: {
        getAccounts: (params = {}) => {
            return GET(url.inspection.accounts, params);
        },
        list: (accountId, params = {}) => {
            return POST(url.inspection.list.replace(":accountId", accountId), params);
        },
        getDetails: (assignmentId) => {
            return GET(url.inspection.details.replace(":assignmentId", assignmentId));
        },
    }

};
export {
    investorPaymentsReceivablesApi
};